module.exports = __webpack_public_path__ + "img/Girl_020004.b23cd843.png";